import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["closeable", "inline", "multiline", "hollow", "StatusDot", "use", "children", "color"];
import styled, { useTheme } from 'foundations-theming/utils';
import { Tag } from '../Tag/Tag';
import { StatusDot } from '../StatusDot/StatusDot';
import { StatusTagProvider } from './StatusTagProvider';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledTextWrapper = styled.span.withConfig({
  displayName: "StatusTag__StyledTextWrapper",
  componentId: "sc-1y7tvvw-0"
})(["display:flex;align-items:center;"]);
export const StatusTag = _ref => {
  let {
      closeable = false,
      inline = false,
      multiline = false,
      hollow = false,
      StatusDot: StatusDotComponent = StatusDot,
      use = 'info',
      children,
      color
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  return /*#__PURE__*/_jsx(StatusTagProvider, {
    tagStyleOverrides: {
      fontFamily: theme.typography['detail-200'].fontFamily,
      fontWeight: theme.typography['detail-200'].fontWeight,
      fontSize: theme.typography['detail-200'].fontSize,
      backgroundColor: theme.color['fill-transparent-default'],
      borderBlockColor: theme.color['fill-transparent-default'],
      borderInlineColor: theme.color['fill-transparent-default'],
      borderRadius: theme.borderRadius['0'],
      borderBlockWidth: theme.borderWidth['0'],
      borderInlineWidth: theme.borderWidth['0'],
      color: theme.color['text-core-subtle'],
      // For closeable StatusTags, setting a specific line-height causes the close button's
      // hover/active styles to be clipped. To avoid this, we unset the line-height
      // (defaults to `normal`) when `closeable` is true.
      lineHeight: !closeable ? theme.typography['detail-200'].lineHeight : undefined,
      paddingInlineStart: theme.space['0'],
      verticalAlign: 'middle'
    },
    children: /*#__PURE__*/_jsx(Tag, Object.assign({
      use: use,
      closeable: closeable,
      inline: inline,
      multiline: children === undefined || multiline
    }, rest, {
      children: /*#__PURE__*/_jsxs(StyledTextWrapper, {
        children: [/*#__PURE__*/_jsx(StatusDotComponent, {
          color: color,
          hollow: hollow,
          use: use
        }), children]
      })
    }))
  });
};
StatusTag.displayName = 'StatusTag';